import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgPower01 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 2v10m6.36-5.36a9 9 0 1 1-12.73 0"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPower01)
export default ForwardRef
